import { __assign, __rest } from "tslib";
import React, { useMemo, useState } from 'react';
import DropdownStateManager from '../DropdownStateManager';
import { PopupContext } from '@wix/da-ds/pkg/popups/PopupContext';
import noop from '../../utils/noop';
import { PopperDropdownContext, } from './PopperDropdownContext';
var PopperDropdownManager = function (_a) {
    var children = _a.children, isInPopup = _a.isInPopup, dropdownProps = __rest(_a, ["children", "isInPopup"]);
    var _b = useState(null), referenceElement = _b[0], setReferenceElement = _b[1];
    var contextData = useMemo(function () { return ({
        setToggleRef: setReferenceElement,
        toggleElement: referenceElement,
    }); }, [referenceElement]);
    return (React.createElement(DropdownStateManager, __assign({}, dropdownProps),
        React.createElement(PopperDropdownContext.Provider, { value: contextData }, isInPopup ? (React.createElement(PopupContext.Provider, { value: { isInPopup: true, setScrollableContentRef: noop } }, children)) : (children))));
};
PopperDropdownManager.displayName = 'PopperDropdownManager';
export default PopperDropdownManager;
//# sourceMappingURL=PopperDropdownManager.js.map